module.exports = __webpack_public_path__ + "static/media/share-primary.f5321a5a.svg";